import { Stack, Input, Button, Typography } from "@mui/material";
import React, { useCallback, useMemo, useRef } from "react";
import { addResource } from "../request/add-resource";
import { FetchStatus } from "../request/model/fetch-status";
export const AddResourceLayout = () => {
    const inputRef = useRef(null);
    const [status, setStatus] = React.useState(FetchStatus.Idle);
    const handleAddResource = useCallback(() => {
        var _a;
        if (!inputRef.current) {
            return;
        }
        setStatus(FetchStatus.Fetching);
        addResource(((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) || "")
            .then(() => {
            setStatus(FetchStatus.Success);
        })
            .catch(() => {
            setStatus(FetchStatus.Error);
        });
    }, []);
    const statusLayout = useMemo(() => {
        switch (status) {
            case FetchStatus.Idle:
                return null;
            case FetchStatus.Fetching:
                return React.createElement(Typography, { color: "primary" }, "Loading");
            case FetchStatus.Error:
                return React.createElement(Typography, { color: "error" }, "Error");
            case FetchStatus.Success:
                return React.createElement(Typography, { color: "success" }, "Succeed");
        }
    }, [status]);
    return (React.createElement(Stack, { spacing: 2, direction: "column" },
        React.createElement(Input, { placeholder: "Enter URL", inputRef: inputRef }),
        React.createElement(Button, { variant: "contained", color: "primary", onClick: handleAddResource, sx: { textTransform: "none" } }, "Add Resource"),
        statusLayout));
};
